import styled from 'styled-components';

export const PageWrapStyles = styled.div`
  position: relative;
  width: 100%;
  max-width: 630px;
  margin: 0 auto;
  min-height: 300px; // TEMP
`;
